import ButtonHeader from './ActionHeaders/ButtonHeader/ButtonHeader'
import ProjektprognosMainHeader from './MainHeader/ProjektprognosMainHeader'
import ProjektprognosSubHeader from './SubHeaders/ProjektprognosSubHeader'

const ProjektprognosHeader = () => (
  <div data-testid="ProjektprognosHeader">
    <ProjektprognosMainHeader />

    <ProjektprognosSubHeader />

    <ButtonHeader />
  </div>
)

export default ProjektprognosHeader
